import * as React from 'react';
import { FC } from 'react';

interface IconProps {
  color?: string;
  size?: number;
  style?: React.CSSProperties;
}

const Mute: FC<IconProps> = ({ color = 'white', size = 12, style }) => (
  <svg 
    width={size} 
    height={size} 
    viewBox="-5.0 -10.0 110.0 135.0" 
    fill={color} 
    style={style}
  >
    <path d="m86.801 39.898c-1.1992-1.1992-3.1016-1.1992-4.1992 0l-5.8984 5.8984-5.8984-5.8984c-1.1992-1.1992-3.1016-1.1992-4.1992 0-1.1992 1.1992-1.1992 3.1016 0 4.1992l5.8984 5.8984-5.8984 5.8984c-1.1992 1.1992-1.1992 3.1016 0 4.1992 0.60156 0.60156 1.3984 0.89844 2.1016 0.89844 0.69922 0 1.5-0.30078 2.1016-0.89844l5.8984-5.8984 5.8984 5.8984c0.60156 0.60156 1.3984 0.89844 2.1016 0.89844 0.69922 0 1.5-0.30078 2.1016-0.89844 1.1992-1.1992 1.1992-3.1016 0-4.1992l-5.8086-5.8945 5.8984-5.8984c1.1016-1.1016 1.1016-3-0.097657-4.2031z" />
    <path d="m19.602 65.199h11.102l-0.003906-30.398h-11.098c-2.3984 0-4.3008 1.8984-4.3008 4.3008v21.898c0 2.3008 1.8984 4.1992 4.3008 4.1992z" />
    <path d="m53.102 20.801-17.301 12.898v32.602l17.301 12.898c0.69922 0.5 1.6016 0.80078 2.5 0.80078 0.69922 0 1.3008-0.19922 2-0.5 1.3984-0.69922 2.3008-2.1992 2.3008-3.8008l-0.003906-51.398c0-1.6016-0.89844-3.1016-2.3008-3.8008-1.4961-0.69922-3.1992-0.60156-4.4961 0.30078z" />
  </svg>
);

export default Mute;